<img
  [src]="path + imageUrl"
  [alt]="'PROGRESS_BAR.CORRECT_ICON' | translate"
  data-testid="node-img" />
